
<script>
import Store from 'store'
export default {
    name: 'CheckoutBilling_FormColumn',
    props: {
        form: Array,
        displayValidationResult: Function,
        label: Object,
    },
    methods:{
        displayOption(element,option){
            return (element.value !== option.value)
        }
    }
   
}
</script>

<template>
    <article>
        <section class="nti-checkout-billing__section" v-for="(formcolumn,columnindex) in form" :key="columnindex">
            <div class="nti-checkout-billing__input-group">
                <template v-for="(formgroup,formgroupindex) in formcolumn">
                    <div class="nti-checkout-billing__input-group" :key="formgroupindex">
                        <template v-for="element in formgroup">
                            <div class="nti-checkout-billing__form-group" :key="element.displayName">
                                <label :for="element.displayName">
                                    <span>{{element.displayName}}</span><span v-if="element.required">*</span></label>
                                
                                <template v-if="element.type === 'select'">
                                    <select
                                        class="form-control custom-select"
                                        :class="displayValidationResult(element)"
                                        :id="element.displayName"
                                        :name="element.name"
                                        :required="element.required"
                                        v-model="element.value"
                                    >
                                        <template v-for="(option,optionindex) in element.options">
                                            <option :key="optionindex" :value="option.value">{{option.text}}</option>
                                        </template>
                                        
                                    </select>
                                </template>

                                <template v-else-if="element.type === 'textarea'">
                                    <textarea cols="20"
                                              class="nti-checkout-billing"
                                              :class="displayValidationResult(element)"
                                              :id="element.displayName"
                                              :name="element.name"
                                              :required="element.required"
                                              :maxlength="element.maxlength"
                                              :maxlengthvalidate="element.maxlengthvalidate"
                                              v-model="element.value"></textarea>
                                    <div v-if="element.maxlengthvalidate"
                                         v-bind:class="{
                                         'invalid-feedback-static' : (element.maxlengthvalidate-element.value.length < 0),
                                            'info-feedback-static': (element.maxlengthvalidate-element.value.length >= 0)
                                            }">
                                        {{ label.inputValidationMaxLengthErrorLabel }} {{ element.maxlengthvalidate }}
                                        ( <strong>{{ element.maxlengthvalidate-element.value.length }}</strong> )
                                    </div>
                                </template>

                                <template v-else>
                                    <input
                                        class="form-control"
                                        :class="displayValidationResult(element)"
                                        :id="element.displayName"
                                        :name="element.name"
                                        :required="element.required"
                                        :type="element.type"
                                        :maxlength="element.maxlength"
                                        v-model="element.value"
                                    />
                                </template>

                                <div v-if="element.required" class="invalid-feedback">{{ label.inputValidationErrorLabel }}</div>
                                
                            </div>
                        </template>
                    </div>
                </template>
            
            </div>
        </section>
    </article>
</template>